export const textValueByCountry = {
  carrier: { UK: 'Carrier', USA: 'Carrier', CANADA: 'Carrier' },
  carrierName: {
    UK: 'Carrier name',
    USA: 'Carrier name',
    CANADA: 'Carrier name'
  },
  consignmentNo: {
    UK: (
      <span>
        Consignment N<sup>o</sup> (WTN)
      </span>
    ),
    USA: 'Consignment No.',
    CANADA: 'Consignment No.'
  },
  consignmentNumber: {
    UK: 'Consignment number (WTN)',
    USA: 'Consignment number',
    CANADA: 'Consignment number'
  }
}
